import Modal from "../Modal/Modal";
import Textfield from "../Input/Textfield";
import Button from "../Button/Button";
import { useModalMeta, useSetModal } from "@/shared/atoms/useModal";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useThemeToAppsmenPost from "@/shared/mutations/theme/useThemeToAppsmenPost";

const ColorTemplateModal = (props) => {
  const { t } = useTranslation();
  const [{ itemId }] = useModalMeta();
  const setModal = useSetModal();
  const { register, handleSubmit, errors } = useForm();
  const mutation = useThemeToAppsmenPost();

  const onSubmit = (data) => {
    mutation.mutateAsync(
      { colorTemplateId: itemId, newName: data.name },
      { onSuccess: () => setModal("", {}) }
    );
  };

  return (
    <Modal onExit={() => setModal("")} {...props}>
      <form
        className="flex flex-col gap-4"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Textfield
          name="name"
          label={t("name")}
          type="string"
          ref={register({
            required: {
              value: true,
              message: t("fieldRequired"),
            },
          })}
          error={errors?.name?.message}
        />
        <Button type="submit" isPending={mutation.isPending}>
          {t("save")}
        </Button>
      </form>
    </Modal>
  );
};

export default ColorTemplateModal;
